import { api } from './http';
import type {
  ActivityListResponse,
  Note,
} from './types';

export const getNotes = (matterId: number) =>
  api.get<Note[]>('/notes', { params: { matter_id: matterId } }).then(r => r.data);

export const createNote = (data: { matter_id: number; subject?: string | null; body?: string | null; pinned?: boolean; created_at?: string | null }) =>
  api.post<Note>('/notes', data).then(r => r.data);

export const updateNote = (id: number, data: Partial<Note>) =>
  api.patch<Note>(`/notes/${id}`, data).then(r => r.data);

export const deleteNote = (id: number) =>
  api.delete(`/notes/${id}`).then(r => r.data);

export const copyNote = (id: number, targetMatterId: number) =>
  api.post<Note>(`/notes/${id}/copy`, { target_matter_id: targetMatterId }).then(r => r.data);

export const getActivities = (matterId: number, params?: { activity_type?: string; limit?: number; offset?: number }) =>
  api.get<ActivityListResponse>(`/matters/${matterId}/activities`, { params }).then(r => r.data);
